import type { Level } from '@/api/types';
import { levelLabel } from '@/lib/format';
import styles from './LevelSegment.module.css';

// 멤버별 권한 화면에서 쓰는 역할 선택 세그먼트 — Stage 행·게임 추가 행·보유 게임 행이 모두 같은 순서(Viewer → Editor)와 스타일을 쓴다.
export const LEVEL_ORDER: readonly Level[] = ['viewer', 'editor'];

export default function LevelSegment({
  value,
  disabled = false,
  groupLabel,
  buttonLabel,
  dimmed = false,
  onSelect,
}: {
  // 현재 활성 역할. null이면 아무것도 켜지지 않는다.
  value: Level | null;
  disabled?: boolean;
  // role="group"의 접근성 이름 (예: "Stage 3 권한").
  groupLabel?: string;
  // 버튼 접근성 이름을 바꿀 때 (예: "Color Sort Viewer로 추가"). 기본은 역할 이름.
  buttonLabel?: (level: Level) => string;
  // 선택 전 상태처럼 흐리게 표시.
  dimmed?: boolean;
  onSelect: (level: Level) => void;
}) {
  return <div className={`${styles.segment} ${dimmed ? styles.dimmed : ''}`} role="group" aria-label={groupLabel}>
    {LEVEL_ORDER.map(level => {
      const active = value === level;
      return <button key={level} type="button"
        className={`${styles.button} ${active ? styles.active : ''}`}
        aria-pressed={active}
        aria-label={buttonLabel?.(level)}
        disabled={disabled}
        onClick={() => onSelect(level)}>
        <span className={`${styles.dot} ${level === 'editor' ? styles.editorDot : styles.viewerDot}`} aria-hidden="true" />
        {levelLabel(level)}
      </button>;
    })}
  </div>;
}
